module.exports = __webpack_public_path__ + "static/media/scene8_furba6.06d6b654.wav";